<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title d-flex align-items-center">
          <span class="mr-2 mt-2 mb-2">Move to Folder</span>
          <Loader v-if="updating"/>
        </p>
        <button @click="close()" class="delete"></button>
      </header>
      <section class="modal-card-body">
        <Loader v-if="loading"/>
        <p v-else-if="noFolders" class="fs-8 text-center text-muted">
          No Folders
        </p>
        <a v-else
           v-for="f in this.folders" class="panel-block d-flex align-items-center"
           @click="moveVideo(f.id)">
          <FolderIcon class="mr-2"/>
          <span class="mr-2">{{f.title}}</span>
          <span class="bold" v-if="video.folder == f.id">(Current Folder)</span>
        </a>
        <a v-if="video.folder" class="panel-block d-flex align-items-center"
           @click="moveVideo(null)">
          <span class="mr-2">Remove from folder</span>
        </a>
      </section>
      <footer class="modal-card-foot">
        <div class="w-100">
          <p class="mb-1">Or create a new folder</p>
          <form @submit.prevent="createFolder">
            <div class="field has-addons w-100p">
              <div class="control is-medium grow-1" :class="creating && 'is-loading'">
                <input
                  v-model="folderTitle"
                  class="input is-medium"
                  placeholder="New Folder name" />
              </div>
              <div class="control is-medium">
                <button class="button is-primary is-medium"
                    :class="creating && 'is-loading'"
                    type="submit">
                    Create
                </button>
              </div>
            </div>
          </form>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import store from '../store'

import FolderIcon from './FolderIcon.vue'
import FolderAddIcon from './FolderAddIcon.vue'
import Loader from './Loader'

export default {
  name: 'MovetoFolderModal',
  props: ['video'],
  components: {
    FolderIcon,
    FolderAddIcon,
    Loader,
  },
  data () {
    return {
      showNewFolderModal: false,
      loading: true,
      updating: false,
      creating: false,
      folderTitle: '',
    }
  },
  async mounted () {
    await store.dispatch('fetchFolders')
    this.loading = false
  },
  computed: {
    folders () {
      return store.state.folders
    },
    noFolders () {
      return this.folders.length === 0
    },
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async moveVideo (folderID) {
      this.updating = true
      await store.dispatch('updateVideoFolder', { videoID: this.video.id, folder: folderID })
      this.updating = false
      this.close()
    },
    async createFolder () {
      this.creating = true
      await store.dispatch('createFolder', { title: this.folderTitle })
      this.folderTitle = ''
      this.creating = false
    },
  },
}
</script>



// WEBPACK FOOTER //
// MoveToFolderModal.vue?f0eb485c